import { createIpaPlatform, createSandboxRosTemplate } from '@services/youtube-platform.service';
import { useTeamsData } from '@lib/hooks/useTeamsData';
import { useEffect, useState } from 'react';
import { getRosPreviewSession, setRosPreviewSession } from '@services/ros-preview.service';
import RosPreviewAlpha from '@components/Sandbox/ros-preview-alpha';
import Loader from '@atoms/Atom/Loader';
import { getAuth } from '@services/identity.service';

export default function SandboxPage({ aiResponsesEnabled, oTemplateId, idx }: any) {
  const [platformId, setPlatformId] = useState(null);
  const [template, setTemplate] = useState(null);

  const teamContext = useTeamsData((s) => s.teamContext);

  const findOrCreateSandboxPlatform = async () => {
    const res = await createIpaPlatform({ userId: teamContext?.oid });
    setPlatformId(res.entity[0].platform_id);
  };

  const findOrFetchTemplate = async () => {
    const rosPreviewSession = getRosPreviewSession();

    if (!rosPreviewSession) return;

    const template = await createSandboxRosTemplate(rosPreviewSession);
    setTemplate(template.entity);
  };

  useEffect(() => {
    if (teamContext?.oid) {
      findOrCreateSandboxPlatform();
    }
  }, [teamContext]);

  useEffect(() => {
    if (oTemplateId) {
      const auth = getAuth();
      setRosPreviewSession(`${auth.id}:${oTemplateId}`);
    }
    findOrFetchTemplate();
  }, []);

  if (!platformId || !template) return <Loader />;

  return <RosPreviewAlpha
    platformId={platformId}
    template={template}
    aiResponsesEnabled={aiResponsesEnabled}
    idx={idx}
  />;
}

export const getServerSideProps = async ({ query }: any) => {
  const { oTemplateId = '' } = query;
  const parsedIdx = Number.parseInt(query.idx, 10);

  const props: any = {
    idx: Number.isNaN(parsedIdx) || parsedIdx < 0 ? 0 : parsedIdx,
    aiResponsesEnabled: query.aiResponsesEnabled === 'true'
  };

  if (oTemplateId) {
    props.oTemplateId = oTemplateId;
  }

  return { props };
};
